import { useGlobalTeam } from "@components/base-layout/header/useGlobalTeam";
import { trpc } from "@utils";
import { useRouter } from "next/router";
import { useCallback, useEffect } from "react";
import useAuth from "./useAuth";

const useHandleRoRedirect = () => {
    const router = useRouter();
    const { logout } = useAuth();
    const { setSelectedTeamId, selectedTeam } = useGlobalTeam();

    const organizationId = router.query.organizationId;

    const { data: userOrganizations } = trpc.team.list.useQuery(undefined, {
        enabled: !!organizationId,
    });

    const checkOrganizationId = useCallback(async () => {
        if (router.pathname !== "/" || !organizationId) {
            return;
        }

        if (
            userOrganizations &&
            !userOrganizations.some((o) => o.id === organizationId)
        ) {
            await logout();
        }

        if (selectedTeam?.organizationId === organizationId) {
            router.replace(router.pathname, undefined, { shallow: true });
            return;
        }
        await setSelectedTeamId({ newOrgId: organizationId as string });

        router.push("/integrations/unified");
    }, [
        logout,
        organizationId,
        router,
        selectedTeam?.organizationId,
        setSelectedTeamId,
        userOrganizations,
    ]);

    useEffect(() => {
        checkOrganizationId();
    }, [checkOrganizationId]);
};

export default useHandleRoRedirect;
